/* eslint-disable @typescript-eslint/naming-convention */

import { DatabaseGetSchemaResult } from '../../../types/database';
import * as commonDefinitions from './commonDefinitions';

function getSchema(): { goodreads_imports: DatabaseGetSchemaResult<'goodreads_imports'>; } {
  return {
    goodreads_imports: {
      schema: {
        primaryKey: 'id',
        additionalProperties: false,
        properties: {
          id: commonDefinitions.getString(100),
          status: {
            type: 'string',
            // `paused` is retained but no longer written; the import now ends in
            // `failed` (with a Retry sheet) rather than a resumable paused state.
            enum: [
              'idle',
              'scraping',
              'done',
              'paused',
              'failed',
            ],
          },
          userId: commonDefinitions.orType(commonDefinitions.getString(100), 'null'),
          rekindledImportId: commonDefinitions.orType(commonDefinitions.integer, 'null'),
          startedAt: commonDefinitions.orType(commonDefinitions.getIndexableTimestamp(), 'null'),
          total: commonDefinitions.integer,
          ratings: commonDefinitions.integer,
          reviews: commonDefinitions.integer,
          // Retained but unused — nothing writes it.
          shelfCounts: {
            type: 'object',
            additionalProperties: commonDefinitions.integer,
          },
          totalMs: commonDefinitions.integer,
          error: commonDefinitions.orType(commonDefinitions.getString(2000), 'null'),
          created: commonDefinitions.getIndexableTimestamp(),
          updated: commonDefinitions.getIndexableTimestamp(),
        },
        required: [
          'id',
          'status',
          'total',
          'ratings',
          'reviews',
          'shelfCounts',
          'totalMs',
          'created',
          'updated',
        ],
        type: 'object',
        version: 1,
      },
      migrationStrategies: {
        // v0 → v1: backfill the new ratings/reviews counts. `paused` stays in
        // the enum and `failed` is additive, so neither needs a data migration.
        1: (oldDoc) => ({
          ...oldDoc,
          ratings: oldDoc.ratings ?? 0,
          reviews: oldDoc.reviews ?? 0,
        }),
      },
    },
  } as const;
}

export default {
  getSchema,
};
